<template>
  <div class="upload">
    <el-upload
      class="upload-demo"
      ref="upload"
      multiple
      accept=".doc, .docx, .DOC, .DOCX, .xls, .xlsx, .pdf"
      :action="uploadHost"
      :data="uploadData"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
      :file-list="file_list"
      :on-format-error="handleFormatError"
      :on-exceeded-size="handleMaxSize"
      :max-size="size"
      :on-remove="remove"
    >
      <el-button size="small" type="primary">点击上传</el-button>
    </el-upload>
  </div>
</template>

<script>
// 引入生成上传参数方法
import { oss } from '@/libs/uploadFile'
import { getpublicImgUrl } from '@/api/base/api-upload'

export default {
  props: {
    max: {
      type: Number,
      default: 0,
    },
    value: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => [],
    },
    size: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Number | String,
      default: 2048,
    },
  },
  data() {
    return {
      showModal: false,
      // 附件上传路径
      uploadHost: '',
      type: 1,
      path: '',
      format: '[]',
      // 附件上传携带参数
      uploadData: {},
      fileData: {
        // 上传后返回的存储的文件名
        fileName: '',
        oFileName: '',
        fileUrl: '',
        uploadRes: null,
      },
      file_list: [],
    }
  },
  mounted() {
    this.init(0, 'public/product/')
    this.file_list = [...this.value]
  },
  methods: {
    // type 0公有 1私有
    init(type, path) {
      this.type = type
      this.path = path
    },
    beforeUpload(file) {
      if (this.max && this.value.length >= this.max) {
        this.$message.warning(`最多能上传${this.max}个文件`)
        return false
      }
      return oss(file.name, this.type, this.path).then((res) => {
        this.uploadHost = res.host
        this.uploadData = res
        this.fileData.fileName = res.key
        this.fileData.oFileName = file.name
        this.fileData.fileUrl = res.key
      })
    },
    // 上传成功的回调函数
    handleSuccess(res, file, fileList) {
      this.uploadRes = res
      if (this.type === 0) {
        // 获取公有链接
        getpublicImgUrl(this.fileData.fileName).then((res) => {
          if (res.code === 0) {
            this.fileData.fileUrl = res.data
            this.fileData.name = this.fileData.fileName
            this.fileData.url = res.data
            // console.log(this.file_list)
            this.$emit('input', [{name: this.fileData.oFileName, url: res.data}])
            this.$message.success('上传成功')
          } else {
            this.$message.error('获取文件链接失败')
          }
        })
      }
    },
    closeHandle() {
      this.showModal = false
    },
    ok() {
      // this.$emit('childByValue', this.file_list)
    },
    remove(file, fileList) {
      this.$emit('input', fileList)
    },
    clearFiles() {
      this.fileData = {
        fileName: '',
        fileUrl: '',
        uploadRes: null,
      }
      this.file_list = []
    },
    handleFormatError(file) {
      this.$message({
        message: '文件格式错误',
        type: 'warning',
      })
    },
    handleMaxSize(file) {
      const size = parseInt(this.size / 1024)
      this.$message({
        message: `文件${file.name}不能超过${size}M`,
        type: 'warning',
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.upload {
  max-width: 400px;
}
</style>
